export const SIGNALS_ONBOARDING_STORAGE_KEY = 'onboarding.positioningSignals.v1.seen';

export type SignalsOnboardingState = {
  isOpen: boolean;
  step: number;
  hasSeen: boolean;
  dismissed: boolean;
};

export const createSignalsOnboardingState = (hasSeen: boolean): SignalsOnboardingState => ({
  isOpen: false,
  step: 0,
  hasSeen,
  dismissed: false,
});

export const readSignalsOnboardingSeen = (storage?: Storage | null): boolean => {
  if (!storage) {
    return false;
  }
  try {
    return storage.getItem(SIGNALS_ONBOARDING_STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
};

export const writeSignalsOnboardingSeen = (storage: Storage | null | undefined, seen = true) => {
  if (!storage) {
    return;
  }
  try {
    storage.setItem(SIGNALS_ONBOARDING_STORAGE_KEY, seen ? 'true' : 'false');
  } catch (error) {
    // Swallow storage errors to avoid breaking onboarding flow.
  }
};

export const shouldAutoOpenSignalsOnboarding = (
  state: SignalsOnboardingState,
  options: { isTrendView: boolean; positioningTourOpen: boolean },
) => {
  return (
    options.isTrendView &&
    !options.positioningTourOpen &&
    !state.isOpen &&
    !state.dismissed &&
    !state.hasSeen
  );
};

export const getReplaySignalsOnboardingState = (state: SignalsOnboardingState): SignalsOnboardingState => ({
  ...state,
  isOpen: true,
  step: 0,
  dismissed: false,
});

export const getCloseSignalsOnboardingState = (state: SignalsOnboardingState): SignalsOnboardingState => ({
  ...state,
  isOpen: false,
  dismissed: true,
});

export const getSkipSignalsOnboardingState = (state: SignalsOnboardingState): SignalsOnboardingState => ({
  ...state,
  isOpen: false,
  hasSeen: true,
  dismissed: false,
  step: 0,
});

export const getDoneSignalsOnboardingState = (state: SignalsOnboardingState): SignalsOnboardingState => ({
  ...state,
  isOpen: false,
  hasSeen: true,
  dismissed: false,
  step: 0,
});
